import { render, staticRenderFns } from "./TopLeftTitle.vue?vue&type=template&id=1ae7fba2&scoped=true&"
import script from "./TopLeftTitle.vue?vue&type=script&lang=js&"
export * from "./TopLeftTitle.vue?vue&type=script&lang=js&"
import style0 from "./TopLeftTitle.vue?vue&type=style&index=0&id=1ae7fba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae7fba2",
  null
  
)

export default component.exports